import { useVerificationFlow } from '../../../Components/shared/VerificationFlow'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../store'
import { verifyTeamMembership } from '../../../store/slices/homebotNetwork/clientTeamMemberships'
import { useState } from 'react'
import * as Sentry from '@sentry/browser'

export const useUnverifiedStep = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { state, dispatch: dispatchVerificationFlow } = useVerificationFlow()
  const { currentPartnerType } = state
  const [isLoading, setIsLoading] = useState(false)

  const membership =
    currentPartnerType === 'RealEstateAgent' ? state.realEstateAgentMembership : state.loanOfficerMembership

  const onRemove = () => {
    dispatchVerificationFlow({ type: 'REMOVE_PARTNER' })
  }

  const onVerify = async () => {
    setIsLoading(true)
    try {
      // First, verify the team membership
      const action = await dispatch(
        verifyTeamMembership({
          clientId: membership.clientId,
          clientTeamMembershipId: membership.id
        })
      )

      if (action.meta.requestStatus === 'fulfilled') {
        // For both partner types, just add the partner (goes to messaging)
        dispatchVerificationFlow({ type: 'ADD_PARTNER' })
      }
    } catch (error) {
      Sentry.captureException(error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    membership,
    onRemove,
    onVerify,
    isLoading
  }
}
